import { Send, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/Reveal";
import { REGISTER_URL, TELEGRAM_URL } from "@/data/site";

export default function ClosingCta() {
  return (
    <section id="gabung" className="relative overflow-hidden py-20 sm:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[420px] w-[820px] -translate-x-1/2 -translate-y-1/2 spotlight-gold blur-3xl" />
      </div>
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <span className="glass mx-auto flex h-14 w-14 items-center justify-center rounded-2xl">
            <Sparkles className="h-6 w-6 text-[#00F2B6]" />
          </span>
          <h2
            data-testid="closing-headline"
            className="mt-6 font-display text-4xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-6xl"
          >
            Siap Membuat Setiap Lot{" "}
            <span className="text-gradient-gold">Lebih Bernilai?</span>
          </h2>
          <p
            data-testid="closing-description"
            className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-zinc-400 sm:text-base"
          >
            Daftar sekarang atau hubungi admin untuk mengetahui ketentuan
            rebate dan pilihan hadiah.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button
              asChild
              data-testid="footer-cta-register-button"
              className="h-14 w-full rounded-full bg-[#F0B429] px-8 text-base font-bold text-[#07090E] hover:bg-[#D9A019] glow-gold sm:w-auto"
            >
              <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer">
                Daftar Sekarang
              </a>
            </Button>
            <Button
              asChild
              data-testid="footer-cta-telegram-button"
              className="h-14 w-full rounded-full glass px-8 text-base font-bold text-white hover:border-teal-400/50 sm:w-auto"
            >
              <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" onClick={() => window.fbq && window.fbq("trackCustom", "TelegramClick")}>
                <Send className="h-4 w-4 text-[#00F2B6]" />
                Tanya Admin di Telegram
              </a>
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
